import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { VomarcLanding } from "@/components/vomarc/VomarcLanding";
import { AdminPage } from "@/components/vomarc/AdminPage";
import { SurveysPage, SurveyTakePage } from "@/components/vomarc/SurveyPages";

function App() {
  return (
    <div className="App" data-testid="vomarc-app-shell">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VomarcLanding />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/surveys" element={<SurveysPage />} />
          <Route path="/surveys/:surveyId" element={<SurveyTakePage />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
